import { create } from "zustand";
import { EstimateTicket, EstimateService } from "~/types/estimate";
import { TInventory } from "~/types/inventory";

export enum EstimateTab {
  OVERVIEW = "overview",
  SERVICES = "services",
  INVENTORY = "inventory",
  NOTES = "notes",
  BILLING = "billing",
}

type State = {
  estimate?: EstimateTicket;
  activeTab: EstimateTab;
  selectedService?: EstimateService;
  selectedInventory?: TInventory;
  showServiceForm: boolean;
  showInventoryModal: boolean;
  showConvertModal: boolean;
  isAddingNewService: boolean;
};

type Actions = {
  setActiveTab: (tab: EstimateTab) => void;
  setEstimate: (estimate: EstimateTicket) => void;
  setSelectedService: (service?: EstimateService) => void;
  setSelectedInventory: (inventory?: TInventory) => void;
  setShowServiceForm: (show: boolean) => void;
  setShowInventoryModal: (show: boolean) => void;
  setShowConvertModal: (show: boolean) => void;
  setIsAddingNewService: (isAdding: boolean) => void;
  openAddService: () => void;
  openEditService: (service: EstimateService) => void;
  closeServiceForm: () => void;
};

const initialState: State = {
  activeTab: EstimateTab.OVERVIEW,
  showServiceForm: false,
  showInventoryModal: false,
  showConvertModal: false,
  isAddingNewService: false,
};

export const useEstimateDetailStore = create<State & Actions>()((set) => ({
  ...initialState,
  setActiveTab: (tab) => set(() => ({ activeTab: tab })),
  setEstimate: (estimate) => set(() => ({ estimate })),
  setSelectedService: (selectedService) => set(() => ({ selectedService })),
  setSelectedInventory: (selectedInventory) => set(() => ({ selectedInventory })),
  setShowServiceForm: (showServiceForm) => set(() => ({ showServiceForm })),
  setShowInventoryModal: (showInventoryModal) => set(() => ({ showInventoryModal })),
  setShowConvertModal: (showConvertModal) => set(() => ({ showConvertModal })),
  setIsAddingNewService: (isAddingNewService) => set(() => ({ isAddingNewService })),

  openAddService: () => set(() => ({
    showServiceForm: true,
    isAddingNewService: true,
    selectedService: undefined,
  })),

  openEditService: (service) => set(() => ({
    showServiceForm: true,
    isAddingNewService: false,
    selectedService: service,
  })),

  closeServiceForm: () => set(() => ({
    showServiceForm: false,
    selectedService: undefined,
  })),
}));
